var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 770.47 770.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.1;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PX-Blue-Circles-BG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 345.26,
    cy: 345.18,
    r: 56.59,
    transform: "translate(-142.95 345.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 425.29,
    cy: 425.21,
    r: 56.59,
    transform: "translate(-176.1 425.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 287.04,
    cy: 287.04,
    r: 138.87,
    transform: "translate(-118.89 287.04) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 182.75,
    cy: 587.71,
    r: 138.87,
    transform: "translate(-362.05 301.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 587.3,
    cy: 183.17,
    r: 138.87,
    transform: "translate(42.5 468.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 483.43,
    cy: 483.43,
    r: 138.87,
    transform: "translate(-200.24 483.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 226.18,
    cy: 226.18,
    r: 224.93,
    transform: "translate(-93.69 226.18) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 544.29,
    cy: 544.29,
    r: 224.93,
    transform: "translate(-225.45 544.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 429.63,
    cy: 340.84,
    r: 28.3,
    transform: "translate(-115.18 403.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 340.04,
    cy: 430.43,
    r: 28.3,
    transform: "translate(-204.76 366.52) rotate(-45)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.1aea7c7b22bf4849597a0b44e5aec962.svg";
export { ForwardRef as ReactComponent };